import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import Icon from '../Icon';

import classes from './styles.module.css';

function useNarrowViewport() {
    const [viewportWidth, setViewportWidth] = useState(0);

    useEffect(() => {
        function update() {
            if (typeof window === 'undefined') return;
            setViewportWidth(window.innerWidth);
        }

        update();
        window.addEventListener('resize', update);

        return () => window.removeEventListener('resize', update);
    }, []);

    return viewportWidth;
}

function ResponsiveSidebarFilters({
    children,
    isOpen,
    onClose,
    title = 'Фильтры',
    onApplyFilters,
    applyLabel = 'Фильтровать',
    isApplyDisabled = false,
}) {
    const viewportWidth = useNarrowViewport();
    const isNarrow = viewportWidth > 0 ? viewportWidth <= 1024 : false;
    const isFullscreen = viewportWidth > 0 ? viewportWidth <= 768 : false;
    const contentRef = useRef(null);
    const [hasApplyTarget, setHasApplyTarget] = useState(false);
    const [applyTargetDisabled, setApplyTargetDisabled] = useState(false);

    function findApplyTarget() {
        if (!contentRef.current) return null;

        return Array.prototype.find.call(contentRef.current.querySelectorAll('button'), (button) => {
            const text = (button.textContent || '').trim().toLowerCase();
            return text.indexOf('фильтровать') !== -1 || text === 'filter';
        });
    }

    useEffect(() => {
        if (!isNarrow || !isOpen) {
            setHasApplyTarget(false);
            setApplyTargetDisabled(false);
            return undefined;
        }

        const timeout = setTimeout(() => {
            const target = findApplyTarget();
            setHasApplyTarget(Boolean(onApplyFilters || target));
            setApplyTargetDisabled(Boolean(target && target.disabled));
        }, 0);

        return () => clearTimeout(timeout);
    }, [children, isNarrow, isOpen, onApplyFilters]);

    function handleApplyClick() {
        if (typeof onApplyFilters === 'function') {
            onApplyFilters();
            return;
        }

        const target = findApplyTarget();
        if (target && !target.disabled) {
            target.click();
        }
    }

    useEffect(() => {
        if (!isNarrow || !isOpen) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        function handleKeyDown(event) {
            if (event.key === 'Escape' && typeof onClose === 'function') {
                onClose();
            }
        }

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isNarrow, isOpen, onClose]);

    return (
        <div className={classes.Wrapper}>
            {!isNarrow && <div className={classes.DesktopSidebar}>{children}</div>}
            {isNarrow && typeof document !== 'undefined'
                ? ReactDOM.createPortal(
                      <div
                          className={`${classes.Overlay} ${isOpen ? classes.OverlayOpen : classes.OverlayClosed}`}
                          onClick={onClose}
                      >
                          <div
                              className={`${classes.Panel} ${isFullscreen ? classes.Fullscreen : classes.Drawer}`}
                              onClick={(event) => event.stopPropagation()}
                          >
                              <div className={classes.Header}>
                                  <h3 className={classes.Title}>{title}</h3>

                                  <button className={classes.CloseButton} onClick={onClose} type="button">
                                      <Icon icon="close" size="18px" />
                                  </button>
                              </div>

                              <div
                                  ref={contentRef}
                                  className={`${classes.Content} ${hasApplyTarget ? classes.ContentWithFooter : ''}`}
                              >
                                  {children}
                              </div>

                              {hasApplyTarget && (
                                  <div className={classes.Footer}>
                                      <button
                                          type="button"
                                          className={classes.ApplyButton}
                                          onClick={handleApplyClick}
                                          disabled={isApplyDisabled || applyTargetDisabled}
                                      >
                                          {applyLabel}
                                      </button>
                                  </div>
                              )}
                          </div>
                      </div>,
                      document.body
                  )
                : null}
        </div>
    );
}

export default ResponsiveSidebarFilters;



// WEBPACK FOOTER //
// ./src/Components/Utils/ResponsiveSidebarFilters/index.js